/* frontend/src/pages/ArticlePage.js */
import React from 'react';
import ArticleDetail from '../components/ArticleDetail';
import './Blog.css';

const ArticlePage = ({ user }) => {
  return <ArticleDetail user={user} />;
};

export default ArticlePage;
